import React from 'react'
import { format } from '../utils/number'
import { getMonth } from '../utils/date'
import { useModal } from '../hooks/modal'
import EmployeeHistorySalary from './EmployeeHistorySalary'

export default function EmployeeSalaryItem({ item, employee }) {
    const [showSalaryModal, hideSalaryModal] = useModal(
        <EmployeeHistorySalary
            employeeSalary={item}
            employeeDetail={employee}
            onCancel={() => hideSalaryModal()} />,
    )

    console.log(item)
    return (
        <tr>
            <td>
                {getMonth(item.annotatedMonth, true) || <span className="is-italic has-text-grey">не указан</span>}
            </td>

            <td>

                <span className="has-text-link">{format(item.payed)} сум </span>
            </td>

            <td>
                {/* <span onClick={showSalaryModal}><i className="icon ion-md-eye" /></span> */}
            </td>
        </tr>
    )
}
